import Icon from "~/components/shared/Icon";
import { ControlButton, ControlPanel } from "~/components/Playground/Controls/ControlButton";

interface Props {
  hidden: boolean;
  onToggle: () => void;
}

export function SkippedStepsControl({ hidden, onToggle }: Props) {
  return (
    <ControlPanel>
      <ControlButton
        label={hidden ? "Show skipped steps" : "Hide skipped steps"}
        onClick={onToggle}
        toggled={!hidden}
      >
        <Icon icon={hidden ? "eye" : "eye-strikethrough"} className="h-[18px] w-5" />
      </ControlButton>
    </ControlPanel>
  );
}
